
import React from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import CHero from '../Common/CHero'
import AboutContact from '../About/AboutContact'
import ServiceContact from './ServiceContact'
import ServiceHero from './ServiceHero'
import ServiceBody from './ServiceBody'

const Services = () => {
  return (
    <>
    <Nav />
   
    <ServiceBody />
    <AboutContact />
    <Footer />
    </>
  )
}

export default Services